export default __webpack_public_path__ + "static/econsans-primary-subset-rg-53422709640db349133a78fe9082ba5e.woff";